import React, { Children } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Calendar as BigCalendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import events from 'events';
import {
  DatePicker, Checkbox, Icon, Popover, Button, Modal, Popconfirm, Radio, LocaleProvider,
} from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Box, Text } from '../../shared/components';
import InlineCard from '../../app/components/InlineCard';
import Page from '../../app/layout/page.layout';
import {
  getAgendaAction,
  resetEventos,
  setCompletadoEvento,
  deleteEvent,
  createEvent,
  updateEvent,
} from '../../../state/actions/creators/agenda/agenda.actioncreator';
import EventFormComponent from '../components/EventForm.component';

require('react-big-calendar/lib/css/react-big-calendar.css');
require('moment/locale/es.js');

const localizer = momentLocalizer(moment);

const CURRENT_DATE = moment().toDate();

const formats = {
  weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dd', culture),
  dayFormat: (date, culture, localizer) => localizer.format(date, 'dd DD', culture),
  timeGutterFormat: (date, culture, localizer) => localizer.format(date, 'HH A', culture),
  dayHeaderFormat: (date, culture, localizer) => localizer.format(date, 'dddd D MMMM YYYY', culture),
};

const simpleDeleteQuestion = '¿Está seguro de que desea eliminar esta tarea?';
const groupDeleteQuestion = 'Borrar tarea repetitiva';
const group1DeleteQuestion = 'De este día';
const group2DeleteEditQuestion = 'De este día y posteriores';
const group3DeleteEditQuestion = 'De todos los días';
const updateRepetitiveTask = 'Actualizar tarea repetitiva';

function onPanelChange(value, mode) {
  console.log(value, mode);
}

function onSelectDate(moment) {
  alert(moment);
}


function EventAgenda({ event }) {
  return (
    <span style={{
      backgroundColor: 'white',
      color: '#595959',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '12px',
    }}
    >
      <em>
        {event.title}

      </em>
      <p>{event.desc}</p>
    </span>
  );
}

const ColoredDateCellWrapper = ({ children, value }) => React.cloneElement(
  Children.only(children),
  {
    style: {
      ...children.style,
      backgroundColor: 'white',
      color: '#595959',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '12px',
    },
  },
);


function Event({ event }) {
  const hoursIni = event.start.getUTCHours();
  const ampmIni = hoursIni >= 12 ? 'PM' : 'AM';
  const classNameTextoEvento = (event.completado) ? 'textoEventoCompletado' : 'textoEventoSinCompletar';

  return (
    <Box style={{
      backgroundColor: 'transparent',
      color: 'rgb(89, 89, 89)',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontWeight: 100,
      lineHeight: '12px',
    }}
    >
      {(event.calendario === 'Vencimientos') ? (<span className="redCircle" />) : (<span className="greenCircle" />) }
      <span className={classNameTextoEvento}>
        {event.start.toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute: '2-digit',
        })}
        {ampmIni}
        {' '}
        <span className="tituloEvento">{event.title}</span>
      </span>
    </Box>
  );
}

function EventWeek({ event }) {
  const hoursIni = event.start.getUTCHours();
  const ampmIni = hoursIni >= 12 ? 'PM' : 'AM';
  const classNameTextoEvento = (event.completado) ? 'textoEventoCompletado' : 'textoEventoSinCompletar';

  return (
    <Box
      className="EventWeek"
      style={{
        backgroundColor: 'transparent',
        color: 'rgb(89, 89, 89)',
        fontFamily: 'Open Sans',
        fontSize: '12px',
        fontWeight: 100,
        lineHeight: '12px',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {(event.calendario === 'Vencimientos') ? (<span className="redCircle" />) : (<span className="greenCircle" />) }
      <span className={classNameTextoEvento}>
        {event.start.toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute: '2-digit',
        })}
        {ampmIni}
        {' '}
        <span className="tituloEvento">{event.title}</span>
      </span>
    </Box>
  );
}

class AgendaMostrar extends React.Component {
  constructor(...args) {
    super(...args);
    const { agenda } = this.props;
    const { listado: listadoAgenda } = agenda;
    this.state = { events };
    this.state.events = [];
    this.state.visible = false;
    this.state.activeEvent = null;
    this.state.selectedDay = CURRENT_DATE;
    this.state.checkTipoTarea = true;
    this.state.checkTipoVencimiento = true;
    this.state.modalEventFormVisible = false;
    this.state.datosWindowEventForm = null;
    this.state.valueDeleteGroup = 'este_evento';
    this.state.valueEditGroup = 'evento_posteriores';
    this.state.stringDiaSeleccion = '';
    this.state.numberDiaSeleccion = '';
    this.state.stringMesSeleccion = '';
    this.state.stringSemanaSeleccion = '';
    this.state.disableUpdateQuestionsWindow = true;
    this.state.disableDeleteQuestionsWindow = true;
    this.state.datosUpdateGroupEvents = null;
    this.state.positionWindow = [100, 100];
  }


  componentWillMount() {
    this.filtrarAgendaTipoTarea();
  }

  componentDidMount() {
    const {
      id, title, desc, start, repetir,
    } = this.state.datosWindowEventForm || '';

    if (start) this.onChangeDiaSeleccion(moment(start));
    else this.onChangeDiaSeleccion(moment());
  }

  showModal = (event) => {
    this.setState({
      visible: true,
      activeEvent: event,
    });
  };

  handleEdit = (e) => {
    const { activeEvent } = this.state;
    const { start } = activeEvent;

    if (start) this.onChangeDiaSeleccion(moment(start));
    else this.onChangeDiaSeleccion(moment());

    this.openWindowEventForm(activeEvent);
    this.setState({
      visible: false,
      activeEvent: null,
    });
  }

  handleShowQuestionDelete= () => {
    const { activeEvent } = this.state;
    const { repetir, cod_grupo_repeticion: codGrupoRepeticion } = activeEvent;

    if ((repetir !== 1) && (codGrupoRepeticion !== null)) {
      this.setState({
        disableDeleteQuestionsWindow: false,
      });
    } else {
      debugger;
      this.setState({
        valueDeleteGroup: 'este_evento',
      });
      this.confirmDelete();
    }
  }

  handleDelete = () => {
    const { deleteEvent } = this.props;
    const { activeEvent, valueDeleteGroup } = this.state;
    const { id } = activeEvent;
    debugger;
    deleteEvent(id, valueDeleteGroup);
    // this.filtrarAgendaTipoTarea();

    this.setState({
      visible: false,
      activeEvent: null,
      valueDeleteGroup: 'este_evento',
      disableDeleteQuestionsWindow: true,
    });
  }

  confirmDelete = () => {
    this.handleDelete();
  }

  confirmUpdate = () => {

  }

  handleCompleted = (e) => {
    const { setCompletadoEvento } = this.props;
    const { activeEvent } = this.state;
    const { id } = activeEvent;
    activeEvent.completado = !activeEvent.completado;

    setCompletadoEvento(id);
    this.setState({
      visible: true,
      activeEvent,
    });

    // this.filtrarAgendaTipoTarea();
  }

  onSubmitFormEvent = (values) => {
    const { createEvent, updateEvent } = this.props;
    const { id, repetir } = values;
    const { datosWindowEventForm } = this.state;
    const { repetir: repetirPrevio } = datosWindowEventForm;

    if (id) {
      if (repetirPrevio !== repetir) {
        this.setState({
          disableUpdateQuestionsWindow: false,
          datosUpdateGroupEvents: values,
        });
      } else {
        updateEvent(values);
      }
    } else {
      createEvent(values);
    }

    // this.filtrarAgendaTipoTarea();
    this.closeWindowEventForm();
  }


  handleSelect = ({ start, end }) => {
    const title = window.prompt('Nuevo evento');
    if (title) {
      this.setState({
        events: [
          ...this.state.events,
          {
            start,
            end,
            title,
          },
        ],
      });
    }
  }

  handleCloseEventWindow = () => {
    this.setState({
      visible: false,
      activeEvent: null,
    });
  }

  onSelectEvent = (event) => {
    // alert(event.title);
    this.showModal(event);
    const hours = event.start.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const classNameTextoEvento = (event.completado) ? 'textoEventoCompletado' : 'textoEventoSinCompletar';
    const classNameTituloWindow = (event.completado) ? 'eventWindowTitleCompleted' : 'eventWindowTitleUncompleted';

    return (
      <Popover
        key={event.id}
        visible
        title={(event.calendario === 'Vencimientos') ? (
          <Box>
            <Text className="bigRedCircle" />
            <span className={classNameTituloWindow}>{event.title}</span>
          </Box>
        ) : (
          <Box>
            <Text className="bigGreenCircle" />
            <span className={classNameTituloWindow}>{event.title}</span>
          </Box>
        )}
        content={(
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            <p>{event.desc}</p>
            <Button
              style={{
                width: ' 50%',
                left: '50%',
              }}
              key="completedEvent"
              type="primary"
              onClick={this.handleCompleted}
            >
          Completado
            </Button>
          </Box>
        )}
      />
    );
  }

  onChangeDayDatePicker = (moment, dateString) => {
    this.setState({ selectedDay: new Date(dateString) });
    this.filtrarAgendaTipoTarea(new Date(dateString));
  }

  onChangePanelDatePicker = (value, mode) => {
    this.setState({ selectedDay: value._d });

    // this.setState({ selectedDay: new Date(dateString) });
    // localizer = momentLocalizer(moment);
  }

  formatEventsAgenda = () => {
    const { agenda } = this.props;
    const { listado: listadoAgenda } = agenda;
    listadoAgenda.forEach(element => console.log(element));
  }

  openWindowEventForm = (datos) => {
    if (datos) {
      const { start } = datos;
      if (start && (start.getHours() === 0)) {
        start.setHours(9);
      }
      this.setState({ datosWindowEventForm: datos });
    }

    this.setState({
      modalEventFormVisible: true,
      // positionWindow: [datos.box.y, datos.box.x],
    });
  }

  closeWindowEventForm = () => {
    this.setState({
      modalEventFormVisible: false,
      datosWindowEventForm: null,
    });
  }

  onChangeCheckedCalendar = (e) => {
    const { getAgendaAction, resetEventos } = this.props;
    const filtrosTipoTarea = [];
    const { checkTipoTarea, checkTipoVencimiento, selectedDay } = this.state;

    if (e.target.id === 'tareasCheckbox') {
      this.setState({ checkTipoTarea: e.target.checked });
      if (e.target.checked) filtrosTipoTarea.push('1');
      if (checkTipoVencimiento) filtrosTipoTarea.push('2');
    } else if (e.target.id === 'vencimientosCheckbox') {
      this.setState({ checkTipoVencimiento: e.target.checked });
      if (checkTipoTarea) filtrosTipoTarea.push('1');
      if (e.target.checked) filtrosTipoTarea.push('2');
    }

    if (filtrosTipoTarea.length === 0) {
      resetEventos();
    } else {
      getAgendaAction(1, 0, 9999, filtrosTipoTarea.join(','), selectedDay);
    }
  }

  filtrarAgendaTipoTarea = (fechaEspecifica) => {
    const { getAgendaAction } = this.props;
    const filtrosTipoTarea = [];
    const { checkTipoTarea, checkTipoVencimiento, selectedDay } = this.state;
    if (checkTipoTarea) filtrosTipoTarea.push('1');
    if (checkTipoVencimiento) filtrosTipoTarea.push('2');
    if (fechaEspecifica) getAgendaAction(1, 0, 9999, filtrosTipoTarea.join(','), fechaEspecifica);
    else getAgendaAction(1, 0, 9999, filtrosTipoTarea.join(','), selectedDay);
  }

  onChangeDeleteGroup = (e) => {
    this.setState({ valueDeleteGroup: e.target.value });
  }

  onChangeEditGroup = (e) => {
    this.setState({ valueEditGroup: e.target.value });
  }

  onChangeDiaSeleccion = (date) => {
    const arrayNumWeek = ['primer', 'segundo', 'tercer', 'último', 'último'];
    const dayString = date.format('dddd').charAt(0).toUpperCase() + date.format('dddd').slice(1);
    const monthString = date.format('MMMM ').charAt(0).toUpperCase() + date.format('MMMM ').slice(1);
    const dateAuxSeleccion = new Date(date.format('YYYY'), date.format('MM'), 0);
    dateAuxSeleccion.setMonth(dateAuxSeleccion.getMonth() - 1);
    const momentAuxSeleccion = moment(dateAuxSeleccion);
    const stringSemanaSeleccion = date.week() - momentAuxSeleccion.week();

    this.setState({
      stringDiaSeleccion: dayString,
      numberDiaSeleccion: date.format('D'),
      stringMesSeleccion: monthString,
      stringSemanaSeleccion: arrayNumWeek[stringSemanaSeleccion - 1],

    });
  }

  closeUpdateQuestionsWindow = () => {
    this.setState({ disableUpdateQuestionsWindow: true });
  }

  closeDeleteQuestionsWindow= () => {
    this.setState({ disableDeleteQuestionsWindow: true });
  }


  updateGroupEvents = () => {
    const { updateEvent } = this.props;
    const { datosUpdateGroupEvents, valueEditGroup } = this.state;
    datosUpdateGroupEvents.tipoCambioRepGrupo = valueEditGroup;
    updateEvent(datosUpdateGroupEvents);

    this.setState({
      visible: false,
      disableUpdateQuestionsWindow: true,
    });
  }


  render() {
    let hoursIni = '';
    let hoursFin = '';
    let ampmIni = '';
    let ampmFin = '';
    let classNameTextoEvento = '';
    let classNameTituloWindow = '';
    let textBtnCompletar = '';
    let eventDay = '';
    let eventMonth = '';
    let eventYear = '';
    let eventIniHour = '';
    let eventIniMinute = '';
    let eventFinHour = '';
    let eventFinMinute = '';
    if (this.state.activeEvent) {
      hoursIni = this.state.activeEvent.start.getUTCHours();
      hoursFin = this.state.activeEvent.end.getUTCHours();
      ampmIni = hoursIni >= 12 ? 'PM' : 'AM';
      ampmFin = hoursFin >= 12 ? 'PM' : 'AM';
      classNameTextoEvento = (this.state.activeEvent.completado) ? 'textoEventoCompletado' : 'textoEventoSinCompletar';
      classNameTituloWindow = (this.state.activeEvent.completado) ? 'eventWindowTitleCompleted' : 'eventWindowTitleUncompleted';
      textBtnCompletar = (this.state.activeEvent.completado) ? 'Deshacer completado' : 'Completar';

      eventDay = (this.state.activeEvent.start.getDate().toString().length === 1) ? `0${this.state.activeEvent.start.getDate()}` : this.state.activeEvent.start.getDate();
      eventMonth = ((this.state.activeEvent.start.getMonth() + 1).toString().length === 1) ? `0${(this.state.activeEvent.start.getMonth() + 1)}` : (this.state.activeEvent.start.getMonth() + 1);
      eventYear = this.state.activeEvent.start.getFullYear();
      eventIniHour = (this.state.activeEvent.start.getUTCHours().toString().length === 1) ? `0${this.state.activeEvent.start.getUTCHours()}` : this.state.activeEvent.start.getUTCHours();
      eventIniMinute = (this.state.activeEvent.start.getUTCMinutes().toString().length === 1) ? `0${this.state.activeEvent.start.getUTCMinutes()}` : this.state.activeEvent.start.getUTCMinutes();
      eventFinHour = (this.state.activeEvent.end.getUTCHours().toString().length === 1) ? `0${this.state.activeEvent.end.getUTCHours()}` : this.state.activeEvent.end.getUTCHours();
      eventFinMinute = (this.state.activeEvent.end.getUTCMinutes().toString().length === 1) ? `0${this.state.activeEvent.end.getUTCMinutes()}` : this.state.activeEvent.end.getUTCMinutes();
    }

    const { agenda: { events } } = this.props;

    const {
      id, title, desc, start, repetir,
    } = this.state.datosWindowEventForm || '';


    return (
      <Page style={{ marginBottom: '40px' }}>
        <InlineCard
          headerText=""

          content={(
            <div style={{ display: '-webkit-box' }}>
              <Button
                style={{
                  flex: 1,
                  border: '0px solid transparent',
                  boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                  position: 'absolute',
                  top: '16px', // '35px',
                  zIndex: '999',
                  right: '24px',
                  width: '126px',
                  color: '#FFFFFF',
                  fontFamily: 'Open Sans',
                  fontSize: '14px',
                  lineHeight: '22px',
                }}
                key="newTask"
                type="primary"
                onClick={this.openWindowEventForm}
              >
                {' '}
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    height: '16px',
                    width: '16px',
                    margin: '0px 8px 0px 0px',
                  }}
                />
                Crear tarea
                {' '}

              </Button>


              <Modal
                title={updateRepetitiveTask}
                centered
                visible={!this.state.disableUpdateQuestionsWindow}
                mask={false}
                footer={null}
                closable={false}
                className="modalQuestionsUpdate"
              >
                <Box>
                  <Box>
                    <Radio.Group style={{ textAlign: 'left' }} onChange={this.onChangeEditGroup} value={this.state.valueEditGroup}>
                      <Box><Radio style={{ margin: '5px 0px 5px 30px' }} value="evento_posteriores">{group2DeleteEditQuestion}</Radio></Box>
                      <Box><Radio style={{ margin: '5px 0px 5px 30px' }} value="todos_eventos">{group3DeleteEditQuestion}</Radio></Box>
                    </Radio.Group>
                  </Box>

                  <Box style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    flexDirection: 'row',
                    marginTop: '16px',
                  }}
                  >
                    <Button
                      onClick={this.closeUpdateQuestionsWindow}
                      style={{
                        height: '24px',
                        boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                        border: '1px solid #e8e8e',
                        marginRight: '8px',
                      }}
                      key="cancelarEvent"
                    >
                    Cancelar
                    </Button>
                    <Button
                      onClick={this.updateGroupEvents}
                      style={{
                        height: '24px',
                        border: '0px solid transparent',
                        boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                      }}
                      key="editEvent"
                      type="primary"
                    >
                    Guardar
                    </Button>
                  </Box>
                </Box>
              </Modal>
              <Text style={{
                fontFamily: 'Open Sans',
                fontSize: '14px',
                lineHeight: '19px',
                textAlign: 'center',
                color: '#403F3D',
                position: 'absolute',
                top: '90px', // '105px',
                zIndex: '999',
                left: '60px',
                marginBottom: '16px',
              }}
              >
              Ver como:
              </Text>

              <div className="rectangulo" style={{ display: 'contents' }}>
                <div style={{
                  height: 314, width: 280, marginRight: -252,
                }}
                >
                  <Text style={{
                    fontFamily: 'Open Sans',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '22px',
                    textAlign: 'center',
                    color: '#595959',
                    marginLeft: '30px',
                    marginTop: '82px',
                  }}
                  >
                  Fecha
                  </Text>
                  <DatePicker
                    open
                    className="datePickerCustomized"
                    dropdownClassName="formEventWindow"
                    size={150}
                    onChange={this.onChangeDayDatePicker}
                    defaultValue={moment()}
                    value={moment(this.state.selectedDay)}
                    onPanelChange={this.onChangePanelDatePicker}
                    mode="date"
                  />

                  <Box id="calendarChecks">

                    <Box>
                      <Text style={{
                        fontFamily: 'Open Sans',
                        fontSize: '14px',
                        fontWeight: '600',
                        lineHeight: '22px',
                        textAlign: 'center',
                        color: '#595959',
                        marginBottom: '12px',
                      }}
                      >
                      Calendarios

                      </Text>

                    </Box>
                    <Box>
                      <Checkbox id="tareasCheckbox" checked={this.state.checkTipoTarea} disabled={false} style={{ marginBottom: '8px' }} className="checkboxGreen" onChange={this.onChangeCheckedCalendar}>Tareas</Checkbox>
                    </Box>
                    <Box>
                      <Checkbox id="vencimientosCheckbox" checked={this.state.checkTipoVencimiento} disabled={false} className="checkboxRed" onChange={this.onChangeCheckedCalendar}>Vencimientos</Checkbox>
                    </Box>
                  </Box>
                </div>
                <div
                  style={{
                    height: 700, width: '100%',
                  }}
                  className="bigCalendar-container"
                >

                  <Modal
                    className="ventanaFormEvento"
                    title=""
                    centered
                    visible={this.state.modalEventFormVisible}
                // onOk={() => this.setModal2Visible(false)}
                // onCancel={() => this.setModal2Visible(false)}
                // cancelText="Cancelar"
                // okText="Crear"
                    mask={false}
                    footer={null}
                    closable={false}
                    style={{
                      width: '460px',
                      height: '324px',
                      // position: 'absolute',
                      // top: this.state.positionWindow[0] - 30,
                      // left: this.state.positionWindow[1],
                    }}
                  >

                    <EventFormComponent
                      loading={false}
                      onSubmit={this.onSubmitFormEvent}
                      onCancel={this.closeWindowEventForm}
                      datos={this.state.datosWindowEventForm}
                      onChangeDiaSeleccion={this.onChangeDiaSeleccion}
                      stringDiaSeleccion={this.state.stringDiaSeleccion}
                      numberDiaSeleccion={this.state.numberDiaSeleccion}
                      stringMesSeleccion={this.state.stringMesSeleccion}
                      stringSemanaSeleccion={this.state.stringSemanaSeleccion}
                    />


                  </Modal>

                  {(this.state.activeEvent)
                    ? (
                      <Modal
                        closable
                        destroyOnClose
                        className="windowInfoEvent"
                        key={this.state.activeEvent.id}
                        onCancel={this.handleCloseEventWindow}
                        title={(this.state.activeEvent.calendario === 'Vencimientos') ? (
                          <Box>
                            <Text className="bigRedCircle" />
                            <span className={classNameTituloWindow}>{this.state.activeEvent.title}</span>
                            <br />
                            <Text className="secondEventTitle">
                              {eventDay}
                              {'-'}
                              { eventMonth}
                              { '-'}
                              { eventYear}
                              { ' / '}
                              {eventIniHour}
                              {':'}
                              {eventIniMinute}
                              {ampmIni}
                              { ' - '}
                              {eventFinHour}
                              {':'}
                              {eventFinMinute}
                              {ampmFin}
                            </Text>
                          </Box>
                        ) : (
                          <Box>
                            <Text className="bigGreenCircle" />
                            <span className={classNameTituloWindow}>{this.state.activeEvent.title}</span>
                            <br />
                            <Text className="secondEventTitle">
                              {eventDay}
                              {'-'}
                              { eventMonth}
                              { '-'}
                              { eventYear}
                              { ' / '}
                              {eventIniHour}
                              {':'}
                              {eventIniMinute}
                              {ampmIni}
                              { ' - '}
                              {eventFinHour}
                              {':'}
                              {eventFinMinute}
                              {ampmFin}
                            </Text>
                          </Box>
                        )}
                        visible={this.state.visible}
                        mask={false}
                        footer={[
                          <Box
                            key="buttonsModal"
                            style={{
                              display: 'flex', justifyContent: 'right', flexDirection: 'row', width: '100%',
                            }}
                          >
                            <Button
                              style={{
                                flex: 1,
                                border: '0px solid transparent',
                                boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                              }}
                              key="editEvent"
                              type="secondary"
                              onClick={this.handleEdit}
                            >
                              <FontAwesomeIcon icon={faEdit} style={{ color: '#949494', height: '16px', width: '18px' }} />
                            </Button>
                            <hr style={{
                              boxSizing: 'border-box',
                              height: '23px',
                              width: '1px',
                              border: '1px solid #E8E8E8',
                            }}
                            />
                            <Button
                              style={{
                                flex: 1,
                                border: '0px solid transparent',
                                boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                              }}
                              key="deleteEvent"
                              type="secondary"
                              onClick={this.handleShowQuestionDelete}
                            >
                              <FontAwesomeIcon icon={faTrash} style={{ color: '#949494', height: '16px', width: '18px' }} />
                            </Button>

                            <Modal
                              title={(this.state.activeEvent.cod_grupo_repeticion !== null) ? (groupDeleteQuestion) : (simpleDeleteQuestion)}
                              centered
                              visible={!this.state.disableDeleteQuestionsWindow}
                              mask={false}
                              footer={null}
                              closable={false}
                              className="modalQuestionDelete"
                            >

                              <Box>

                                <Box>
                                  <Radio.Group style={{ textAlign: 'left' }} onChange={this.onChangeDeleteGroup} value={this.state.valueDeleteGroup}>
                                    <Box><Radio style={{ margin: '5px 0px 5px 30px' }} value="este_evento">{group1DeleteQuestion}</Radio></Box>
                                    <Box><Radio style={{ margin: '5px 0px 5px 30px' }} value="evento_posteriores">{group2DeleteEditQuestion}</Radio></Box>
                                    <Box><Radio style={{ margin: '5px 0px 5px 30px' }} value="todos_eventos">{group3DeleteEditQuestion}</Radio></Box>
                                  </Radio.Group>
                                </Box>
                                <Box style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  flexDirection: 'row',
                                  marginTop: '16px',
                                }}
                                >
                                  <Button
                                    onClick={this.closeDeleteQuestionsWindow}
                                    style={{
                                      // flex: 1,
                                      height: '24px',
                                      boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                                      border: '1px solid #e8e8e',
                                      marginRight: '8px',
                                    }}
                                    key="cancelarEvent"
                                  >
                                  Cancelar
                                  </Button>
                                  <Button
                                    onClick={this.confirmDelete}
                                    style={{
                                      // flex: 1,
                                      height: '24px',
                                      border: '0px solid transparent',
                                      boxShadow: '0 0px 0 rgba(0, 0, 0, 0.015)',
                                    }}
                                    key="editEvent"
                                    type="primary"
                                  >
                                   Guardar
                                  </Button>
                                </Box>
                              </Box>
                            </Modal>

                          </Box>,
                        ]}
                      >
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                          <p className="descripcionEvento">{this.state.activeEvent.desc}</p>
                          <Box style={{
                            display: 'flex',
                            justifyContent: 'right',
                            alignItems: 'flex-end',
                            flexDirection: 'column',
                          }}
                          >
                            <Button
                              style={{
                                height: '24px',
                              }}
                              key="completedEvent"
                              type="primary"
                              onClick={this.handleCompleted}
                            >
                              {textBtnCompletar}
                            </Button>
                          </Box>
                        </Box>
                      </Modal>
                    ) : <div />}
                  <BigCalendar
                    onShowMore={(events, date) => console.log(date)}
                    selectable
                    popup
                    localizer={localizer}
                    events={events}// {this.formatEventsAgenda}// {this.state.events}
                    defauldDate={CURRENT_DATE}
                    onNavigate={(date) => {
                      this.setState({ selectedDay: date });
                      this.filtrarAgendaTipoTarea(date);
                    }}
                    date={this.state.selectedDay}
                    startAccessor="start"
                    endAccessor="end"
                    // timeslots={1}
                    // step={15}
                    views={['day', 'week', 'month']}
                    defaultView={Views.MONTH}
                    onSelectEvent={event => this.onSelectEvent(event)}
                    onSelectSlot={this.openWindowEventForm}
                    min={new Date(this.state.selectedDay.setHours(9, 0, 0, 0))}
                    max={new Date(this.state.selectedDay.setHours(23, 59, 59, 59))}
                    messages={{
                      next: <Icon
                        type="right"
                        style={{
                          fontSize: 16,
                          padding: '3px',
                          borderRadius: '90%',
                          border: '1px solid #D9D9D9',
                        }}
                      />,
                      previous: <Icon
                        type="left"
                        style={{
                          fontSize: 16,
                          padding: '3px',
                          borderRadius: '90%',
                          border: '1px solid #D9D9D9',
                        }}
                      />,
                      today: 'Hoy',
                      month: 'Mes',
                      week: 'Semana',
                      day: 'Dia',
                      showMore: total => `${total} más`,
                    }}
                    formats={formats}
                    components={{
                      event: Event.bind(this),
                      day: {
                        event: Event.bind(this),
                      },
                      week: {
                        event: EventWeek.bind(this),
                      },
                      month: {
                        event: Event.bind(this),
                      },
                    }}
                  />
                </div>
              </div>
            </div>
      )}
        />
      </Page>
    );
  }
}

function mapStateToProps({
  agenda,
}) {
  return {
    agenda,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getAgendaAction,
    resetEventos,
    setCompletadoEvento,
    deleteEvent,
    createEvent,
    updateEvent,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AgendaMostrar);
